<template>
  <div class="p-4">
    <div>{{ $t("configuration_hello") }}</div>
    <div class="mr-4 mt-4 lg:mr-4 lg:mt-0 lg:mt-4">
      <toggle-button color="#000" v-model="nightMode" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lang: sessionStorage.getItem("lang") || "en",
      nightMode: JSON.parse(sessionStorage.getItem("nightMode")) || false
    };
  },
  watch: {
    nightMode: function() {
      sessionStorage.setItem("nightMode", JSON.stringify(this.nightMode));
      this.$root.$emit("theme", this.nightMode);
    }
  }
};
</script>